var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:{
    'gt-animation': true,
    up: _vm.up,
    down: _vm.down,
    left: _vm.left,
    right: _vm.right,
  },attrs:{"t":"1640588809063","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"72365","xmlns:xlink":"http://www.w3.org/1999/xlink","data-darkreader-inline-fill":"","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M476.501333 727.2448L45.397333 298.8032a20.48 20.48 0 0 1 14.404267-34.952533H916.821333a20.48 20.48 0 0 1 14.5408 34.884266l-425.847466 428.4416a20.48 20.48 0 0 1-29.013334 0.068267z","fill":"#888888","p-id":"72366"}})])}
var staticRenderFns = []

export { render, staticRenderFns }